import * as types from '../../constants/K007/ActionTypes';
import * as ctypes from '../../constants/common/ActionTypes';
import * as commonLogic from '../../logic/CommonLogic';
import * as defaultValue from '../../constants/common/ConstDefaultValue';
import * as ContextTitle from '../../constants/K007/ContextSortTitle';
import * as apiWrapper from '../../logic/APIWrapper';
import * as dispTypes from '../../constants/common/ConstDispTypes';
import * as cookies from '../../logic/Cookies';

/**
* コントロールの選択項目を変更したN秒後にAPIを呼び出しグリッドを更新する
*/
export function checkAPICall() {

  return (dispatch, getState) => {
    const state = getState();
    const planTime = state.callApiPlanTime;
    const nowTime = new Date();

    if (planTime && nowTime > planTime) {

      if (!state.controlErrFlg) {

        dispatch({ type: ctypes.UPDATE_LOADING });
        sessionStorage.setItem('condition', JSON.stringify(state));
        sessionStorage.setItem('gmnID', 'K007');

        let latestTermId;
        let latestNohinFrom;
        let latestNohinTo;

        // 期間リスト用パラメータ
        const paramTerm = {
          time_units: state.kikanUnit,
          partition: state.kubun
        };

        // メーカー情報取得
        apiWrapper.getBrands((err, makerList) => {
          if (err) {
            dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: makerList });
          } else {
            state.itemList.makerList = makerList;
            dispatch({ type: ctypes.LOADED_MAKER, itemList: state.itemList });
          }
        });

        if (state.pskubun == 0) {
          /** パチンコ機種別集計データ期間リスト */
          apiWrapper.getPachinkoTerms(paramTerm, (err, termData) => {

            if (err) {
              dispatch({ type: ctypes.ERROR, error: err, errPara: termData });
            } else {

              if (termData != null && termData.length !== 0) {
                latestTermId = state.term ? state.term : commonLogic.getLastTermKey(termData);

                // パチンコ機種別集計データ期間リスト
                let targetData = termData.find(t => t.id === latestTermId);
                if (targetData == undefined || targetData == null) {
                  // 指定した期間が存在しなかった場合、最終期間を設定する
                  targetData = termData[termData.length - 1];
                  latestTermId = targetData.id;
                }
                const fromDate = state.termStart ? state.termStart : commonLogic.toLocaleString(new Date(targetData.from_date));
                const toDate = state.termEnd ? state.termEnd : commonLogic.toLocaleString(new Date(targetData.to_date));
                dispatch({ type: ctypes.LOADED_KIKAN, term: latestTermId, termData: termData, termStart: fromDate, termEnd: toDate });

                /** パチンコ最新情報取得 */
                apiWrapper.getPachinkoNewmodels((err, termKaishibi) => {
                  if (err) {
                    dispatch({ type: ctypes.ERROR, error: err, errPara: termKaishibi });
                  } else {
                    latestNohinFrom = state.nohinkaishibiFrom;
                    latestNohinTo = state.nohinkaishibiTo;

                    if (latestNohinFrom != null && latestNohinTo != null && termKaishibi.data.length !== 0) {
                      dispatch({ type: ctypes.LOADED_KAISHIBI, term: termKaishibi, nohinFrom: latestNohinFrom, nohinTo: latestNohinTo });
                      const paramKishu = commonLogic.getParamKishuWithNohinFromTo(state, latestNohinFrom, latestNohinTo);
                      apiWrapper.getPachinko(paramKishu, (err, kishuNameList) => {
                        if (err) {
                          dispatch({ type: ctypes.ERROR, error: err, errPara: kishuNameList });
                        } else {
                          dispatch({ type: types.LOADED_KISHU_LIST, kishuList: kishuNameList });
                        }
                      });
                      getPachiData(state, dispatch, latestTermId, latestNohinFrom, latestNohinTo);
                    } else {
                      const err = new Error(404);
                      dispatch({ type: ctypes.ERROR, error: err, errPara: null });
                    }
                  }
                });
              } else {
                const err = new Error(404);
                dispatch({ type: ctypes.ERROR, error: err, errPara: null });
              }
            }
          });

        } else {
          /** スロット機種別集計データ期間リスト */
          apiWrapper.getSlotTerms(paramTerm, (err, termData) => {
            if (err) {
              dispatch({ type: ctypes.ERROR, error: err, errPara: termData });
            } else {

              if (termData != null && termData.length !== 0) {
                latestTermId = state.term ? state.term : commonLogic.getLastTermKey(termData);

                // パチンコ機種別集計データ期間リスト
                let targetData = termData.find(t => t.id === latestTermId);
                if (targetData == undefined || targetData == null) {
                  // 指定した期間が存在しなかった場合、最終期間を設定する
                  targetData = termData[termData.length - 1];
                  latestTermId = targetData.id;
                }

                const fromDate = state.termStart ? state.termStart : commonLogic.toLocaleString(new Date(targetData.from_date));
                const toDate = state.termEnd ? state.termEnd : commonLogic.toLocaleString(new Date(targetData.to_date));
                dispatch({ type: ctypes.LOADED_KIKAN, term: latestTermId, termData: termData, termStart: fromDate, termEnd: toDate });

                /** スロット最新情報取得 */
                apiWrapper.getSlotNewModels((err, termKaishibi) => {
                  if (err) {
                    dispatch({ type: ctypes.ERROR, error: err, errPara: termKaishibi });
                  } else {
                    latestNohinFrom = state.nohinkaishibiFrom;
                    latestNohinTo = state.nohinkaishibiTo;

                    if (latestNohinFrom != null && latestNohinTo != null && termKaishibi.data.length !== 0) {
                      dispatch({ type: ctypes.LOADED_KAISHIBI, term: termKaishibi, nohinFrom: latestNohinFrom, nohinTo: latestNohinTo });
                      const paramKishu = commonLogic.getParamKishuWithNohinFromTo(state, latestNohinFrom, latestNohinTo);
                      apiWrapper.getSlot(paramKishu, (err, kishuNameList) => {
                        if (err) {
                          dispatch({ type: ctypes.ERROR, error: err, errPara: kishuNameList });
                        } else {
                          dispatch({ type: types.LOADED_KISHU_LIST, kishuList: kishuNameList });
                        }
                      });
                      getSlotData(state, dispatch, latestTermId, latestNohinFrom, latestNohinTo);
                    } else {
                      const err = new Error(404);
                      dispatch({ type: ctypes.ERROR, error: err, errPara: null });
                    }
                  }
                });
              } else {
                const err = new Error(404);
                dispatch({ type: ctypes.ERROR, error: err, errPara: null });
              }
            }
          });
        }
      }
    }
  };
}

/**
 * 画面が表示された時のイベントリスナー
 */
export function onMounted() {

  return (dispatch, getState) => {
    const state = getState();
    dispatch({ type: types.LOADING });
    sessionStorage.setItem('condition', JSON.stringify(state));
    sessionStorage.setItem('gmnID', 'K007');

    let latestDateId;
    let latestNohinFrom;
    let latestNohinTo;

    // 期間リスト用パラメータ
    const paramTerm = {
      time_units: state.kikanUnit,
      partition: state.kubun
    };

    // メーカー情報取得
    apiWrapper.getBrands((err, makerList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: makerList });
      } else {
        state.itemList.makerList = makerList;
        dispatch({ type: ctypes.LOADED_MAKER, itemList: state.itemList });
      }
    });

    if (state.pskubun == 0) {
      /** パチンコ機種別集計データ期間リスト */
      apiWrapper.getPachinkoTerms(paramTerm, (err, termData) => {
        if (err) {
          dispatch({ type: ctypes.ERROR, error: err, errPara: termData });
        } else {
          let termStart;
          let termEnd;
          if (state.term == null) {
            latestDateId = commonLogic.getLastTermKey(termData);
            termStart = commonLogic.toLocaleString(new Date(termData[termData.length - 1].from_date));  // 最新週（開始日）
            termEnd = commonLogic.toLocaleString(new Date(termData[termData.length - 1].to_date));  // 最新週（終了日）
          } else {
            if (termData != null && termData.length !== 0) {
              latestDateId = state.term;
              termStart = commonLogic.toLocaleString(new Date(termData[termData.length - 1].from_date));  // 最新週（開始日）
              termEnd = commonLogic.toLocaleString(new Date(termData[termData.length - 1].to_date));  // 最新週（終了日）
            } else {
              latestDateId = null;
            }
          }

          if (latestDateId != null) {

            // パチンコ機種別集計データ期間リスト
            dispatch({ type: ctypes.LOADED_KIKAN, term: latestDateId, termData: termData, termStart: termStart, termEnd: termEnd });

            /** パチンコ最新情報取得 */
            apiWrapper.getPachinkoNewmodels((err, termKaishibi) => {
              if (err) {
                dispatch({ type: ctypes.ERROR, error: err, errPara: termKaishibi });
              } else {
                latestNohinFrom = state.nohinkaishibiFrom ? state.nohinkaishibiFrom : '';
                latestNohinTo = state.nohinkaishibiTo ? state.nohinkaishibiTo : '';
                if (latestNohinFrom != null && latestNohinTo != null && termKaishibi.data.length !== 0) {
                  dispatch({ type: ctypes.LOADED_KAISHIBI, term: termKaishibi, nohinFrom: latestNohinFrom, nohinTo: latestNohinTo });
                  // グラフ・グリッドデータ（パチンコ）
                  const paramKishu = commonLogic.getParamKishuWithNohinFromTo(state, latestNohinFrom, latestNohinTo);
                  apiWrapper.getPachinko(paramKishu, (err, kishuNameList) => {
                    if (err) {
                      dispatch({ type: ctypes.ERROR, error: err, errPara: kishuNameList });
                    } else {
                      dispatch({ type: types.LOADED_KISHU_LIST, kishuList: kishuNameList });
                    }
                  });
                  getPachiData(state, dispatch, latestDateId, latestNohinFrom, latestNohinTo);
                } else {
                  const err = new Error(404);
                  dispatch({ type: ctypes.ERROR, error: err, errPara: null });
                }
              }
            });
          } else {
            const err = new Error(404);
            dispatch({ type: ctypes.ERROR, error: err, errPara: null });
          }
        }
      });
    } else {
      /** スロット機種別集計データ期間リスト */
      apiWrapper.getSlotTerms(paramTerm, (err, termData) => {
        if (err) {
          dispatch({ type: ctypes.ERROR, error: err, errPara: termData });
        } else {
          let termStart;
          let termEnd;
          if (state.term == null) {
            latestDateId = commonLogic.getLastTermKey(termData);
            termStart = commonLogic.toLocaleString(new Date(termData[termData.length - 1].from_date));  // 最新週（開始日）
            termEnd = commonLogic.toLocaleString(new Date(termData[termData.length - 1].to_date));  // 最新週（終了日）
          } else {
            if (termData != null && termData.length !== 0) {
              latestDateId = state.term;
              termStart = commonLogic.toLocaleString(new Date(termData[termData.length - 1].from_date));  // 最新週（開始日）
              termEnd = commonLogic.toLocaleString(new Date(termData[termData.length - 1].to_date));  // 最新週（終了日）
            } else {
              latestDateId = null;
            }
          }

          if (latestDateId != null) {

            // スロット機種別集計データ期間リスト
            dispatch({ type: ctypes.LOADED_KIKAN, term: latestDateId, termData: termData, termStart: termStart, termEnd: termEnd });

            /** スロット最新情報取得 */
            apiWrapper.getSlotNewModels((err, termKaishibi) => {
              if (err) {
                dispatch({ type: ctypes.ERROR, error: err, errPara: termKaishibi });
              } else {
                latestNohinFrom = state.nohinkaishibiFrom ? state.nohinkaishibiFrom : '';
                latestNohinTo = state.nohinkaishibiTo ? state.nohinkaishibiTo : '';
                if (latestNohinFrom != null && latestNohinTo != null && termKaishibi.data.length !== 0) {
                  dispatch({ type: ctypes.LOADED_KAISHIBI, term: termKaishibi, nohinFrom: latestNohinFrom, nohinTo: latestNohinTo });
                  const paramKishu = commonLogic.getParamKishuWithNohinFromTo(state, latestNohinFrom, latestNohinTo);
                  apiWrapper.getSlot(paramKishu, (err, kishuNameList) => {
                    if (err) {
                      dispatch({ type: ctypes.ERROR, error: err, errPara: kishuNameList });
                    } else {
                      dispatch({ type: types.LOADED_KISHU_LIST, kishuList: kishuNameList });
                    }
                  });
                  // グラフ・グリッドデータ（スロット）
                  getSlotData(state, dispatch, latestDateId, latestNohinFrom, latestNohinTo);
                } else {
                  const err = new Error(404);
                  dispatch({ type: ctypes.ERROR, error: err, errPara: null });
                }
              }
            });
          } else {
            const err = new Error(404);
            dispatch({ type: ctypes.ERROR, error: err, errPara: null });
          }
        }
      });
    }
  };
}

/**
 * グラフ・グリッドデータ（パチンコ）
 */
function getPachiData(state, dispatch, latestDateId, nohinFrom, nohinTo) {

  // パラメータ取得
  const paramPachi = getParamSummary(state, latestDateId, nohinFrom, nohinTo, K007_LIST_DISPLAY_KISHU_COUNT, defaultValue.DEFAULT_OFFSET);

  // グリッドデータ（パチンコ）
  apiWrapper.getPachinkoSummary(paramPachi, (err, data) => {
    if (err) {
      dispatch({ type: types.ERROR, error: err, errPara: data });
    } else {
      dispatch({ type: types.LOADED_PACHI_DATA, data: data });
    }
  });
}

/**
 * グラフ・グリッドデータ（スロット）
 */
function getSlotData(state, dispatch, latestDateId, nohinFrom, nohinTo) {

  // パラメータ取得
  const paramSlot = getParamSummary(state, latestDateId, nohinFrom, nohinTo, K007_LIST_DISPLAY_KISHU_COUNT, defaultValue.DEFAULT_OFFSET);
  commonLogic.getParamAdditional(state, paramSlot);

  // グリッドデータ（スロット）
  apiWrapper.getSlotSummary(paramSlot, (err, data) => {
    if (err) {
      dispatch({ type: types.ERROR, error: err, errPara: data });
    } else {
      dispatch({ type: types.LOADED_SLOT_DATA, data: data });
    }
  });
}

/**
 * 平日・休日変更時のイベントリスナー
 */
export function changeDay(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME); // N秒後
  return {
    type: ctypes.CHANGE_DAY,
    time: time,
    value: value
  };
}

/**
 * PS区分変更時のイベントリスナー
 */
export function changePSKubun(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME); // N秒後
  return {
    type: ctypes.CHANGE_PSKUBUN,
    time: time,
    value: value
  };
}

/**
 * レート変更時のイベントリスナー
 */
export function changeRate(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME); // N秒後
  return {
    type: ctypes.CHANGE_RATE,
    value: value,
    time: time
  };
}

/**
 * PS&レート変更時のイベントリスナー
 */
export function changePSRate(pskubun, rateId, sortKey) {
  cookies.setItem('scrollPosition', -1);
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME); // N秒後
  // N秒後にグリッド部のデータ更新を行う
  return {
    type: ctypes.CHANGE_PS_RATE,
    pskubun: pskubun,
    rate: rateId,
    sortKey: sortKey,
    time: time
  };
}

/**
 * タイプ変更時のイベントリスナー
 * @param {*} value
 */
export function changeType(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CHANGE_TYPE,
    value: value,
    time: time
  };
}

/**
 * メーカを変更時のイベントリスナー
 * @param {*} value
 */
export function changeMaker(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CHANGE_MAKER,
    value: value,
    time: time
  };
}

/**
 * 区分変更時のイベントリスナー
 * @param {*} value
 */
export function changeKubun(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CHANGE_KUBUN,
    value: value,
    time: time
  };
}

/**
 * 機種名検索の時
 */
export function clickSearch() {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // 初期値の時API 呼び出しメッソドを呼び出して再取得する。
  return (dispatch, getState) => {
    const state = getState();
    const kishu = state.kishu;
    const time = new Date();

    time.setSeconds(time.getSeconds()); // 今の時間
    dispatch({
      type: ctypes.CLICK_SEARCH,
      time: time,
      value: kishu
    });
  };
}

/**
 * 機種名検索の時(スマホ)
 */
export function clickSearchSummary() {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // 初期値の時API 呼び出しメッソドを呼び出して再取得する。
  return (dispatch, getState) => {
    const state = getState();
    const kishu = state.kishu;
    const time = new Date();

    time.setSeconds(time.getSeconds()); // 今の時間
    dispatch({
      type: ctypes.CLICK_SEARCH_SUMMARY,
      time: time,
      value: kishu
    });
  };
}

/**
 * 機種名クリアの時
 */
export function clickClear() {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CLEAR_KISHU,
    time: time
  };
}

/**
 * 機種名クリアの時(スマホ)
 */
export function clickClearSummary() {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CLEAR_KISHU_SUMMARY,
    time: time
  };
}

/**
 * 機種名変更の時
 */
export function changeModelName(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  return {
    type: ctypes.CHANGE_KISHU,
    value: value
  };
}

/**
 * 反映ボタン押下イベント
 * @param {} value 
 * @returns 
 */
export function applyFilterForm(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME); // N秒後

  return {
    type: ctypes.FILTER_FORM_APPLY,
    time: time,
    value: value
  };
}


/**
 * 更新ボタン押下時のイベントリスナー
 */
export function clickUpdate() {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);

  // 初期値の時API 呼び出しメッソドを呼び出して再取得する。
  return (dispatch, getState) => {
    let state = getState();
    let urlTerm = commonLogic.getTermFromURL();
    if (urlTerm == null) {
      state.term = commonLogic.getLastTermKey(state.termData);
    } else {
      state.term = urlTerm;
    }

    const time = new Date();
    time.setMilliseconds(time.getMilliseconds()); // 今の時間
    dispatch({
      type: types.CLICK_UPDATE,
      kubun: commonLogic.getKubunFromURL(),  // 区分
      dispFlg: dispTypes.DAYOFF_TYPEOFF,
      nohinkaishibi: commonLogic.getNohinFromURL(),
      condType: commonLogic.getTypeFromURL(),
      maker: defaultValue.DEFAULT_MAKER,
      kishu: '',
      dayFlg: commonLogic.getdayFlgFromURL(),
      pskubun: commonLogic.getPSKubun(),
      rate: commonLogic.getRateFromURL(),
      gouki: commonLogic.getGoukiFromURL(),
      smartYugiki: commonLogic.getSmartYugikiFromURL(),
      yugitype: commonLogic.getParamYugiType(),
      time: time,

    });
  };
}

export function onScroll(element) {

  return (dispatch, getState) => {

    const state = getState();

    const scrollPosition = element.clientHeight + element.scrollTop; // todo:clientHeight,offsetHeight,どっちのHeightを使うのが正しいのか

    // スクロール高さ
    const scrollHeight = element.scrollHeight;

    // 最下部までスクロールした場合、処理を実行する。
    let positionDiff = Math.round((scrollHeight - scrollPosition) / scrollHeight * 100) / 100;
    if (positionDiff <= 0.00) {

      if (!state.focusFlg) {

        const nextOffset = state.offset + K007_LIST_DISPLAY_KISHU_COUNT;

        if (nextOffset <= K007_LIST_MAX_COUNT && nextOffset <= state.dataCnt) {
          cookies.setItem('scrollPosition', commonLogic.getScrollLeft());
          state.focusFlg = true;
          let dataLimit = K007_LIST_DISPLAY_KISHU_COUNT;
          if ((K007_LIST_MAX_COUNT - nextOffset) < K007_LIST_DISPLAY_KISHU_COUNT ||
            (state.dataCnt - nextOffset) < K007_LIST_DISPLAY_KISHU_COUNT) {
            if (K007_LIST_MAX_COUNT < state.dataCnt) {
              dataLimit = K007_LIST_MAX_COUNT - nextOffset + defaultValue.DEFAULT_OFFSET;
            } else {
              dataLimit = state.dataCnt - nextOffset + defaultValue.DEFAULT_OFFSET;
            }
          }
          // スクロールダウンした時パラメータ設定する。
          const params = getParamSummary(state, state.term, state.nohinkaishibiFrom, state.nohinkaishibiTo, dataLimit, nextOffset);

          // API 呼び出し
          dispatch({ type: ctypes.SCROLL_LOADING });

          if (state.pskubun == 0 && state.dataPachi != null) {
            apiWrapper.getPachinkoSummary(params, (err, data) => {
              if (err) {
                dispatch({ type: types.ERROR, error: err, errPara: data });
              } else {
                // dispatch({ type: types.SCROLL, value: element.scrollTop });
                dispatch({ type: types.LOADED_NEXT_PACHI_DATA, data: data });
              }
            });
          } else if (state.pskubun == 1 && state.dataSlot != null) {
            commonLogic.getParamAdditional(state, params);
            apiWrapper.getSlotSummary(params, (err, data) => {
              if (err) {
                dispatch({ type: types.ERROR, error: err, errPara: data });
              } else {
                // dispatch({ type: types.SCROLL, value: element.scrollTop });
                dispatch({ type: types.LOADED_NEXT_SLOT_DATA, data: data });
              }
            });
          }
        }
      }
    }
  };
}

/**
 * 検索ボタンにフォーカスが当たった時は更新時間をリセットする
 */
export function stopUpdate() {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', commonLogic.getScrollLeft());
  return {
    type: ctypes.STOP_UPDATE,
    time: null
  };
}

/**
 * 検索ボタンにフォーカスが外れた時は更新時間をN秒後に設定する
 */
export function blurAction() {
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME); // N秒後
  return {
    type: ctypes.ON_BLUR,
    time: time
  };
}

/**
 * タイプが 'すべて', ブランドが'すべて', 納品開始日が'全期間'の場合
 * パラメータに指定しないように設定する。
 * 機種リスト取得のためにパラメータを設定する。
 * @param {*} state
 * @param {*} termWeek
 * @param {*} nohinkaishiFrom
 * @param {*} nohinkaishiTo
 * @param {*} dataLimit
 * @param {*} dataOffset
 */
export function getParamSummary(state, termWeek, nohinkaishiFrom, nohinkaishiTo, dataLimit, dataOffset) {
  let param = {
    term: termWeek,
    partition: state.kubun,
    rate: state.rate,
    q: state.kishu,
    limit: dataLimit,
    offset: dataOffset,
  };
  if (nohinkaishiFrom) {
    param['nohinkaishi_from'] = nohinkaishiFrom;
  }
  if (nohinkaishiTo) {
    param['nohinkaishi_to'] = nohinkaishiTo;
  }
  if (state.type != 0) {
    param['type'] = state.type;
  }
  if (state.maker != 0) {
    param['brand'] = state.maker;
  }
  if (state.yugitype !== '' && state.pskubun == 0) {
    param['yugi_type'] = state.yugitype;
  }
  if (state.sortKey != null) {
    param['sort_order'] = state.sortOrder;
    param['sort_key'] = state.sortKey;
    if (ContextTitle.MODEL_SORT_KEY.includes(state.sortKey)) {
      param['sort_target'] = 'model';
    } else {
      param['sort_target'] = state.sortDay;
    }

  }
  if (state.smartYugiki !== '' && state.smartYugiki != null) {
    param['smart_flag'] = state.smartYugiki;
  }
  return param;
}

/**
 * reRender
 */
export function reRender(value) {
  return {
    type: ctypes.RE_RENDER,
    isPc: value
  };
}

/**
 * WebFontAPIをコール
 */
export function callWebFontAPI() {
  return {
    type: ctypes.CALL_WEB_FONT_API
  };
}

/**
 * 遊技タイプ変更時のイベントリスナー
 * @param {*} value
 */
export function changeYugiType(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  cookies.setItem('scrollPosition', -1);
  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CHANGE_YUGI_TYPE,
    value: value,
    time: time
  };
}

/**
 * 号機変更時のイベントリスナー
 * @param {*} value
 */
export function changeGouki(value) {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CHANGE_GOUKI,
    value: value,
    time: time
  };
}

/**
 * スマート遊技機変更時のイベントリスナー
 * @param {*} value
 */
export function changeSmartYugiki(value) {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', -1);

  // N秒後にグリッド部のデータの更新を行う
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + UPDATE_PENDING_TIME);  // N秒後
  return {
    type: ctypes.CHANGE_SMARTYUGIKI,
    value: value,
    time: time
  };
}

/**
 * ソート押下時のイベントリスナー
 */
export function clickSort(sortKey) {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', commonLogic.getScrollLeft());

  // 初期値の時API 呼び出しメッソドを呼び出して再取得する。
  return (dispatch, getState) => {
    const state = getState();
    let paramSortKey = sortKey;
    let paramSortOrder = 'desc';
    if (state.sortKey == sortKey) {
      if (state.sortOrder == 'asc') {
        paramSortKey = null;
        paramSortOrder = null;
      } else if (state.sortOrder == 'desc') {
        paramSortOrder = 'asc';
      }
    }

    const time = new Date();
    time.setMilliseconds(time.getMilliseconds()); // 今の時間
    dispatch({
      type: types.CLICK_SORT,
      sortKey: paramSortKey,
      sortOrder: paramSortOrder,
      sortDay: 'everyday',
      time: time,

    });
  };
}
/**
 * 平日・休日ソート押下時のイベントリスナー
 */
export function clickDaySort(sortKey, sortDay) {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', commonLogic.getScrollLeft());

  // 初期値の時API 呼び出しメッソドを呼び出して再取得する。
  return (dispatch, getState) => {
    const state = getState();
    let paramSortKey = sortKey;
    let paramSortOrder = 'desc';
    let paramSortDay = sortDay;
    if (state.sortKey == sortKey && state.sortDay == sortDay) {
      if (state.sortOrder == 'asc') {
        paramSortKey = null;
        paramSortOrder = null;
        paramSortDay = null;
      } else if (state.sortOrder == 'desc') {
        paramSortOrder = 'asc';
      }
    }

    const time = new Date();
    time.setMilliseconds(time.getMilliseconds()); // 今の時間
    dispatch({
      type: types.CLICK_SORT,
      sortKey: paramSortKey,
      sortOrder: paramSortOrder,
      sortDay: paramSortDay,
      time: time,

    });
  };
}


/**
 * ソート順変更
 */
export function changeSortOrder(newSortOrder) {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', commonLogic.getScrollLeft());

  return (dispatch, getState) => {
    const state = getState();
    let paramSortKey = state.sortKey;
    let paramSortOrder = newSortOrder;
    let paramSortTarget = state.sortTarget;
    let paramSortTargetDisp = state.sortTargetDisp;
    let paramSortTargetIndex = state.sortTargetIndex;

    const time = new Date();
    time.setMilliseconds(time.getMilliseconds()); // 今の時間
    dispatch({
      type: types.CLICK_SORT,
      sortKey: paramSortKey,
      sortOrder: paramSortOrder,
      sortDay: 'everyday',
      sortTarget: paramSortTarget,
      sortTargetDisp: paramSortTargetDisp,
      sortTargetIndex: paramSortTargetIndex,
      time: time,
    });
  };
}


/**
 * 表示する値変更時のイベントリスナー
 */
export function changeDisplayItem(value) {
  cookies.setItem('scrollPosition', -1);
  return {
    type: ctypes.CHANGE_DISPLAY_ITEM,
    value: value,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * ソート押下時のイベントリスナー
 */
export function clickSortSummary(sortKey, sortOrder) {
  // 入手したスクロールポジションをcookieに保存
  cookies.setItem('scrollPosition', commonLogic.getScrollLeft());

  // 初期値の時API 呼び出しメッソドを呼び出して再取得する。
  return (dispatch, getState) => {
    const state = getState();
    let paramSortKey = sortKey;
    let paramSortOrder = sortOrder;

    const time = new Date();
    time.setMilliseconds(time.getMilliseconds()); // 今の時間
    dispatch({
      type: types.CLICK_SORT_SUMMARY,
      sortKey: paramSortKey,
      sortOrder: paramSortOrder,
      sortDay: 'everyday',
      time: time,

    });
  };
}